import React, { useEffect, useRef, useState } from 'react';
import './css/style.css'; // Assuming CSS is in a separate file
import { Chart, registerables } from 'chart.js'; // Assuming you're using chart.js for charts
import Rellax from 'rellax'; // Assuming you're using Rellax for parallax effects
import Tokenomics from '../../components/Tokenomics';
import websiteStore from '../../mobx/websiteStore';
import { Motion, spring } from 'react-motion';
import Modal from "react-modal";
import { toast } from 'react-toastify';
import CryptoJS from "crypto-js";
import { ethers } from 'ethers';
import { motion, useInView } from "framer-motion";

Chart.register(...registerables);

const useMultipleInView = (count, options = { threshold: 0.1 }) => {
    const refs = useRef([]);
    const [inViewStates, setInViewStates] = useState(Array(count).fill(false));
    

    useEffect(() => {
        const observers = refs.current.map((ref, index) => {
            if (!ref) return null;

            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setInViewStates((prev) => {
                            const newState = [...prev];
                            newState[index] = true;
                            return newState;
                        });
                    }
                },
                options
            );

            observer.observe(ref);
            return observer;
        });

        return () => {
            observers.forEach((observer, index) => {
                if (observer && refs.current[index]) {
                    observer.unobserve(refs.current[index]);
                }
            });
        };
    }, [count, options]);

    return [refs, inViewStates];
};

function NewPage() {
    const [showModal, setShowModal] = useState(false);
    const [walletAddress, setWalletAddress] = useState("");
    const [amount, setAmount] = useState("");
    const [showModalRefer, setShowModalRefer] = useState(false);
    // const [timeLeft, setTimeLeft] = useState("00:00:00:00");
    // const [isProceedButtonDisabled, setIsProceedButtonDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [rewardData, setRewardData] = useState(null);
    const secretKey =  "AuthHandShake@SnowBallBoss"

    const [referralId, setReferralId] = useState("");
    const [userReferralId, setUserReferralId] = useState("");
    const [snowPurchase, setSnowPurchase] = useState("");
    const [hovered, setHovered] = useState(false);
    const [displayValue, setDisplayValue] = useState(0); // Calculated value
    // Function to handle text copying
    //   const copyText = (event) => {
    //     event.preventDefault();
    //     const text = document.getElementById("copyText").innerText;
    //     const button = document.getElementById("copyButton");

    //     navigator.clipboard.writeText(text).then(() => {
    //         button.innerText = "Copied";
    //         button.style.background = "#81c784"; // Change color to green
    //         setTimeout(() => {
    //             button.innerText = "Copy";
    //             button.style.background = "#4fc3f7"; // Reset color
    //         }, 2000);
    //     }).catch(err => {
    //         console.error("Failed to copy:", err);
    //     });
    //   };

    // Function to convert BTC to LTC

    const encodedSearch = encodeURIComponent(referralId);
    console.log(encodedSearch, "ref");

    const referralUrl = `https://snowballboss.com?referral=${encodedSearch}`;
    // const referralUrl = `http://192.168.29.120:3000/new-page?referral=${encodedSearch}`;

    const handleBtcInput = (event) => {
        let btcValue = parseFloat(event.target.value) || 0;
        let conversionRate = 1848.083333333333;
        document.getElementById('ltcInput').value = (btcValue * conversionRate).toFixed(2);
    };

    console.log(secretKey,"secreate key");
    
    const imageRef = useRef(null);
    let lastScrollTop = 0;

    // Function to check if the element is in the viewport
    const isInViewport = (element) => {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
    };

    const contractAddress = "0x81dcD01b9503563feEF165710e687680901Abd7A";

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (imageRef.current && isInViewport(imageRef.current)) {
                if (scrollTop > lastScrollTop) {
                    // Scrolling down
                    imageRef.current.classList.add("animate-down");
                    imageRef.current.classList.remove("animate-up");
                } else {
                    // Scrolling up
                    imageRef.current.classList.add("animate-up");
                    imageRef.current.classList.remove("animate-down");
                }
            } else if (imageRef.current) {
                // Reset when the element is out of view
                imageRef.current.classList.remove("animate-down", "animate-up");
            }

            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // Ensure it doesn't go negative
        };

        window.addEventListener("scroll", handleScroll);

        // Cleanup on component unmount
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // Run once after the component mounts

    useEffect(() => {
        // Get the URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        // Get the referral code from the query string (referral=KAQB8F)
        const query = urlParams.get('referral');
        if (query) {
            setUserReferralId(decodeURIComponent(query)); // Decode to get the original value
        }
    }, []);


    useEffect(() => {

        setDisplayValue(amount * 100);
    }, [amount]);




    const userSnowPurchase = snowPurchase?.data?.snowballAmount;

    console.log(userSnowPurchase, "userSnowPurchase");

    const timelineItems = [
        {
            date: 'Q1 2025',
            title: '🚀 Launch & Initial Growth',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed efficitur ex sit amet massa scelerisque scelerisque. Aliquam erat volutpat. Aenean interdum finibus efficitur. Praesent dapibus dolor felis, eu ultrices elit molestie.'
        },
        {
            date: 'Q2 2025',
            title: '🌍 Community Building',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed efficitur ex sit amet massa scelerisque scelerisque. Aliquam erat volutpat. Aenean interdum finibus efficitur. Praesent dapibus dolor felis, eu ultrices elit molestie.'
        },
        {
            date: 'Q3 2025',
            title: '🎉 Growth & Expansion',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed efficitur ex sit amet massa scelerisque scelerisque. Aliquam erat volutpat. Aenean interdum finibus efficitur. Praesent dapibus dolor felis, eu ultrices elit molestie.'
        },
        {
            date: 'Q4 2025',
            title: '⚙️ Scaling',
            description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed efficitur ex sit amet massa scelerisque scelerisque. Aliquam erat volutpat. Aenean interdum finibus efficitur. Praesent dapibus dolor felis, eu ultrices elit molestie.'
        }
    ];

    const [refs, inViewStates] = useMultipleInView(timelineItems.length);


    // const refsAndInViews = timelineItems.map(() => useInView({
    //     threshold: 0.1,
    //     triggerOnce: true
    // }));

    const refsAndInViews = useMultipleInView(timelineItems.length);


    useEffect(() => {
        const checkReferralId = async () => {
            if (walletAddress) {
                const response = await websiteStore.getReferral(walletAddress);
                setReferralId(response.status ? response.data : "");
            }
        };
        checkReferralId();
    }, [walletAddress]);

    const handleReferralReward = async () => {
        console.log("anik");

        if (!walletAddress || !userReferralId) {
            toast.error("Wallet address or referral ID is missing.");
            return;
        }

        console.log(displayValue, "displayValue");



        setIsLoading(true); // Show loading state
        try {
            const param = {
                walletAddress: walletAddress,
                userReferralId: userReferralId,
                userSnowPurchase: displayValue,
            }
            console.log(param, "param");

            const rewardResponse = await websiteStore.getReferralReward(param);
            console.log(rewardResponse, "rewardResponse");

            setRewardData(rewardResponse);
            if (rewardResponse.status) {
                // Handle the successful reward response (e.g., show a success message, update state, etc.)
                toast.success("Referral reward fetched successfully!");
            } else {
                toast.error("Failed to fetch referral reward.");
            }
        } catch (error) {
            console.error("Error fetching referral reward:", error);
            toast.error("An error occurred while fetching referral reward.");
        } finally {
            setIsLoading(false); // Hide loading state
        }
    };

    const connectWallet = async (walletType) => {
        try {
            if (walletType === "metamask" || walletType === "trustwallet") {
                if (window.ethereum) {
                    const accounts = await window.ethereum.request({
                        method: "eth_requestAccounts",
                    });
                    setWalletAddress(accounts[0]);
                } else {
                    // If MetaMask extension is not found, try to open MetaMask app on mobile or desktop browser
                    toast.error("MetaMask not found! Redirecting to MetaMask App...");

                    // Deep link for MetaMask mobile or app browsers
                    const metamaskDeepLink = "https://metamask.app.link";
                    window.location.href = metamaskDeepLink; // Redirects to the MetaMask app or mobile browser
                }
            } else if (walletType === "phantom") {
                if (window.solana && window.solana.isPhantom) {
                    const response = await window.solana.connect();
                    setWalletAddress(response.publicKey.toString());
                } else {
                    toast.error("Phantom Wallet not found!");
                }
            }
        } catch (error) {
            console.error("Error connecting wallet:", error);
            toast.error("Failed to connect wallet."); // Added user-friendly error message
        }
        setShowModal(false);
    };



    const handleAmountChange = (e) => {
        setAmount(e.target.value);
    };

    const handleButtonClickMOdal = () => {
        if (!userReferralId) {
            setShowModalRefer(true);
        }
        else {
            sendUSDT();
        }

    };


    // const encrypt = (text, secretKey) => {
    //     const iv = crypto.randomBytes(16); // Generate random IV
    //     const cipher = crypto.createCipheriv('aes-256-cbc', secretKey, iv);
    //     let encrypted = cipher.update(text, 'utf8', 'hex');
    //     encrypted += cipher.final('hex');
    //     return iv.toString('hex') + ':' + encrypted; // Combine IV and encrypted text
    // };

    // Function to send USDT


    const sendUSDT = async () => {
        if (!window.ethereum) {
            toast.error("Please install MetaMask or connect to Ethereum!");
            return;
        }

        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();

        try {
            setIsLoading(true);

            // USDT Contract address (for Ethereum Mainnet)
            const usdtAddress = "0x4d5080D5f756413eD91811ff8958B5071F10b8D4";
            const usdtABI = [{ "inputs": [{ "internalType": "address", "name": "_teamWallet", "type": "address" }], "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Burn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "amountBurned", "type": "uint256" }], "name": "MilestoneBurn", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "from", "type": "address" }, { "indexed": true, "internalType": "address", "name": "to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "value", "type": "uint256" }], "name": "Transfer", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "teamWallet", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "Vesting", "type": "event" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "allowance", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "spender", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "approve", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "balanceOf", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "burn", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "burnAddress", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "burnOnMilestone", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "cliffPeriod", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "communityAirdropAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "contractOwner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "decimals", "outputs": [{ "internalType": "uint8", "name": "", "type": "uint8" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "developmentReserveAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "lastVestingTime", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "liquidityPoolAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "marketingPartnershipsAllocation", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "milestoneBurnThreshold", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "mint", "outputs": [], "stateMutability": "pure", "type": "function" }, { "inputs": [], "name": "name", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "releaseTeamTokens", "outputs": [], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [], "name": "symbol", "outputs": [{ "internalType": "string", "name": "", "type": "string" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "teamVestingPeriod", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "teamWallet", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalBurnableTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalBurned", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalSupply", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [], "name": "totalVestedTokens", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "stateMutability": "view", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transfer", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }, { "inputs": [{ "internalType": "address", "name": "sender", "type": "address" }, { "internalType": "address", "name": "recipient", "type": "address" }, { "internalType": "uint256", "name": "amount", "type": "uint256" }], "name": "transferFrom", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "stateMutability": "nonpayable", "type": "function" }];

            // Replace with the recipient's wallet address
            const recipientAddress = "0xeCb8305E476B91367B8c7Ae0C4a2988D82a441be";

            const amountInWei = ethers.utils.parseUnits(amount, 18);

            const contract = new ethers.Contract(usdtAddress, usdtABI, signer);

            // Send transaction with a manual gas limit
            const tx = await contract.transfer(recipientAddress, amountInWei, {
                gasLimit: ethers.utils.hexlify(100000), // Set gas limit
            });

            // Wait for transaction confirmation
            const receipt = await tx.wait();
            // alert("Transaction successful!", tx);
            if (receipt && receipt.status === 1) {
                const transactionHash = tx.hash;
                const encryptedTxHash = CryptoJS.AES.encrypt(transactionHash, secretKey);
                const payload = {
                    transactionHash: encryptedTxHash, // Transaction hash
                    amountToSend: ethers.utils.formatUnits(amountInWei, 18), // Convert amount back to readable format
                    recipientAddress: await signer.getAddress(), // Sender's wallet address
                    location: "Bilaspur"
                };
                const response = await websiteStore.swapUsdt(payload);

                setSnowPurchase(response);

                // Handle the response
                if (response.status) {
                    toast.success(response?.message || "Transaction successful!");
                    if (!referralId) {
                        handleReferralReward();
                    }
                } else {
                    toast.error(response?.message || "API Error: Transaction failed.");
                }
            }
        } catch (error) {
            // console.error("Transaction failed:", error);
            toast.error("Transaction failed. Please try again.");
        } finally {
            setIsLoading(false);
            setAmount("");
            setWalletAddress("");
        }
    };

    const handleModalClose = (confirm) => {
        if (confirm) {
            // Proceed without referral ID
            alert("Proceeding without Referral ID");
        }
        setShowModalRefer(false); // Close modal
    };

    // useEffect(() => {
    //     websiteStore?.getTime();
    // }, []);

    // useEffect(() => {
    //     setTimeLeft(toJS(websiteStore?.data?.time));
    //     const timerId = setInterval(() => {
    //         websiteStore?.getTime();
    //     }, 1000);

    //     // Cleanup function to clear the interval
    //     return () => clearInterval(timerId);
    // }, [websiteStore?.data?.time]);

    const [timeLeft, setTimeLeft] = useState('');

    useEffect(() => {
        const specificDate = new Date('2025-01-28T00:00:00Z');

        const updateTime = () => {
            const now = new Date();
            const timeDifference = specificDate - now;

            if (timeDifference <= 0) {
                setTimeLeft('Time’s up!');
                return;
            }

            const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            setTimeLeft(`${days}d ${hours}h ${minutes}m ${seconds}s`);
        };

        updateTime(); // Initial call to set the time immediately
        const timerId = setInterval(updateTime, 1000); // Update every second

        // Cleanup interval on component unmount
        return () => clearInterval(timerId);
    }, []);

    // Handle button click
    const handleButtonClick = () => {
        setShowModalRefer(false);
        sendUSDT();

    };
    const isProceedButtonDisabled = !amount;

    console.log(referralId, "referralId");

    const handleNavigate = () => {
        const element = document.getElementById("buysnowball");
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }


    // Effect hook for initializing JavaScript functionality
    useEffect(() => {
        // Initialize Rellax (if available)
        const rellaxInstance = new Rellax(".rellax");

        // Get the canvas element
        const canvas = document.getElementById("myPieChart");
        if (!canvas) return;

        const ctx = canvas.getContext("2d");

        const data = {
            labels: ["Community Rewards & Airdrops", "Team Allocation", "Marketing & Partnerships", "Presale Liquidity", "Development Reserve", "DEX & CEX Listing"],
            datasets: [
                {
                    label: "Colors Distribution",
                    data: [15, 10, 15, 10, 15, 35],
                    backgroundColor: [
                        "rgba(54, 162, 235, 0.7)",
                        "rgba(219, 86, 52, 0.7)",
                        "rgba(161, 22, 131, 0.7)",
                        "rgba(28, 34, 190, 0.7)",
                        "rgba(73, 22, 174, 0.7)",
                        "rgba(109, 14, 90, 0.7)",
                    ],
                    borderColor: "black",
                },
            ],
        };

        const config = {
            type: "doughnut",
            data: data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                cutout: "70%",
                plugins: {
                    legend: {
                        display: false,
                    },
                },
            },
        };

        // Initialize Chart.js instance
        const chartInstance = new Chart(ctx, config);

        return () => {
            // Cleanup Chart.js
            chartInstance.destroy();

            // Cleanup Rellax
            rellaxInstance.destroy();
        };
    }, []);

    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(contractAddress)
            .then(() => {
                alert("Contract address copied to clipboard!");
            })
            .catch((err) => {
                console.error("Failed to copy: ", err);
            });
    };

    return (
        <div className="main-content position-relative overflow-hidden">
            {/* Header */}
            <header className="header-container style2 bg-black nav-down">
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light border-0">
                        <img src="assets/images/s2.png" width={200} alt="logo" className='position-fixed head-logo' />
                        <button className="navbar-toggler px-0 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav mx-auto mb-2 mb-lg-0" id="navbar-main">
                                <li className="nav-item menu-item-has-children">
                                    <a className="nav-link text-white" href="#">Home</a>
                                    {/* <ul className="sub-menu">
                                        <li className="menu-item"><a href="home-1.html">Home 1</a></li>
                                        <li className="menu-item"><a href="home-2.html">Home 2</a></li>
                                        <li className="menu-item"><a href="home-3.html">Home 3</a></li>
                                        <li className="menu-item"><a href="home-4.html">Home 4</a></li>
                                    </ul> */}
                                </li>
                                <li className="nav-item"><a className="nav-link text-white" href="#About">About</a></li>
                                <li className="nav-item"><a className="nav-link text-white" href="#HowToBuy">How To Buy</a></li>
                                <li className="nav-item"><a className="nav-link text-white" href="#Tokenomics">Tokenomics</a></li>
                                <li className="nav-item"><a className="nav-link text-white" href="#Roadmap">Roadmap</a></li>
                                <li className="nav-item"><a className="nav-link text-white" href="#Faq">Faq</a></li>
                            </ul>
                        </div>
                        <a href="#Exchange" className="btn bg-theme-pink border border-black text-black d-none d-lg-flex px-4">Exchange</a>
                    </nav>
                </div>
            </header>

            {/* Banner */}
            <div className="banner-container-two bg-theme-cyan2">
                <div className="container position-relative h-100">
                    <div className="banner-content h-100">
                        <div className="row justify-content-center h-100">
                            <div className="col-10 justify-content-center text-center">
                                <h1 className="ls-n8 lh-5 text-black mb-3 text-uppercase display6-size">Welcome to Snowball</h1>
                                <p className="fs-18 lh-28 text-black mx-lg-5 mb-4">Snowball Coin is a decentralized cryptocurrency designed for exponential growth, leveraging compounding rewards, fast transactions, and a strong community-driven ecosystem.</p>
                                <ul className="navbar-nav d-flex flex-row gap-3 justify-content-center">
                                    <li><a href="#" aria-label="mastodon" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-title="Mastodon"><i className="bi-mastodon text-black display1-size"></i></a></li>
                                    <li><a href="#" aria-label="telegram"><i className="bi-telegram text-black display1-size"></i></a></li>
                                    <li><a href="#" aria-label="twitter"><i className="bi-twitter-x text-black display1-size"></i></a></li>
                                    <li><a href="#" aria-label="instagram"><i className="bi-instagram text-black display1-size"></i></a></li>
                                    <li><a href="#" aria-label="twitch"><i className="bi-twitch text-black display1-size"></i></a></li>
                                </ul>
                            </div>

                            <div className="col-12 mb-5 margin-header">
                                <img src="assets/images/trio.png" alt="banner" className="w-100 position-relative z-10 rellax" data-rellax-speed="-3" />
                            </div>
                        </div>
                    </div>
                    
                    <div class="black-hole"></div>

                    <div data-rellax-speed="-0.5" className="rellax mountain-1"><img src="assets/images/mountain-1.png" alt="mountain-1" /></div>
                    <div data-rellax-speed="-1.5" className="rellax mountain-2"><img src="assets/images/mountain-2.png" alt="mountain-2" /></div>

                    <div data-rellax-speed="-3" className="rellax galaxy-1"><img src="assets/images/moon-1.png" alt="moon-1" /></div>
                    <div data-rellax-speed="-1" className="rellax galaxy-2"><img src="assets/images/moon-2.png" alt="moon-2" /></div>
                </div>
            </div>

            {/* Additional sections like 'Exchange', 'About', 'How To Buy', 'Tokenomics', etc., can be implemented similarly */}

            {/* Countdown */}


            <div className="about-container-two position-relative" id="Exchange">
                <div className="element-1 rellax" data-rellax-speed={-2}><img src="assets/images/element-1.png" alt="element" /></div>
                <div className="about-wrap py-lg-4 bg-theme-pink2">
                    <div className="container py-sm-5">
                        <div className="row justify-content-center">
                            <div className="row gy-4 gx-4">
                                <div className="col-lg-6 px-lg-5">
                                    <h2 className="display4-size ls-n5 theme-text-stork text-white mb-4 lh-5">We bring together a vibrant
                                        with community of invest advocates to champion</h2>
                                    <div className="d-flex flex-row justify-content-between">
                                        <form className="p-2 bg-gray-900 rounded-3 mt-3 w-100">
                                            <div className="row ">
                                                <div className="col-8 d-flex align-items-center">
                                                    <span id="copyText" className="text-white fs-16 ps-sm-3">{contractAddress}</span>
                                                </div>
                                                <div className="col-4">
                                                    <button className="btn bg-theme-cyan border border-black text-black w-100 copy-btn" id="copyButton" onClick={copyToClipboard}>Copy</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className="col-lg-6 px-xl-5">
                                    {/* <video autoPlay muted loop className="background-video">
                                            <source src="assets/img/background-video-snowball.mp4" type="video/mp4" />
                                        </video> */}
                                    <div className="p-4 text-center shadow border border-black tiker rounded-3 text-black bg-light">
                                        <h3 className="display1-size mb-0">Countdown Price Increase</h3>
                                        {/* <video autoPlay muted loop className="background-video">
                                            <source src="assets/img/background-video-snowball.mp4" type="video/mp4" />
                                        </video> */}
                                        <div className="d-flex flex-row gap-sm-4 gap-4 justify-content-center my-3" id="mycountdown" />
                                        <h4 className="fs-18 ls-n2 mt-0">creating a greener future for all.</h4>
                                        <div className="px-md-5 mb-3">
                                            <div className="row gx-3 gy-3 my-3 d-flex justify-content-center">
                                                <div className="col-4">
                                                    <a href="#" className="btn bg-white border border-black shadow text-black w-100 d-flex flex-row gap-2 align-items-center ps-2"><img src="assets/img/usdt.png" alt="coin" width={20} height={20} />USDT</a>
                                                </div>
                                                <div className="col-8">
                                                    <div className="input-group shadow border border-black rounded-2">
                                                        <input type="text" className="form-control border-0 shadow-none fs-17 lh-1 pe-0" aria-label="btc" placeholder='Here is Referral code' id="btcInput" value={userReferralId || ""}
                                                            onChange={(e) => setUserReferralId(e.target.value)} readOnly />
                                                    </div>
                                                    {/* <input type="text" class="form-control fs-18" value="2.4"> */}
                                                </div>
                                                {/* <div className="col-4">
                                                    <a href="#" className="btn bg-white border border-black shadow text-black w-100 d-flex flex-row gap-2 align-items-center ps-2"><img src="assets/images/litecoin.png" alt="coin" width={25} height={25} />LTC</a>
                                                </div> */}
                                            </div>
                                            <div className="row gx-3 gy-3 mb-3">
                                                <div className="col">
                                                    <div className="input-group shadow border border-black rounded-2">
                                                        <input type="number" className="form-control border-0 shadow-none fs-17 lh-1 pe-0" aria-label="btc" placeholder='USDT' id="btcInput" value={amount}
                                                            onChange={handleAmountChange} />
                                                        <span className="input-group-text bg-transparent border-0"><img src="assets/img/usdt.png" alt="coin" width={20} height={20} /></span>
                                                    </div>
                                                    {/* <input type="text" class="form-control fs-18" value="2.4"> */}
                                                </div>
                                                <div className="col">
                                                    <div className="input-group shadow border border-black rounded-2">
                                                        <input type="number" className="form-control border-0 shadow-none fs-17 lh-1 pe-0" aria-label="ltc" defaultValue="0" id="ltcInput" value={displayValue}
                                                            readOnly
                                                            onChange={handleAmountChange} />
                                                        <span className="input-group-text bg-transparent border-0"><img src="assets/img/front.png" alt="coin" width={20} height={20} /></span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row gx-3 gy-3 mb-3">
                                                <div className="col">
                                                    <div className="input-group shadow border border-black rounded-2">
                                                        <input type="text" className="form-control border-0 shadow-none fs-17 lh-1 pe-0"
                                                            value={walletAddress}
                                                            disabled placeholder='Wallet Address' />
                                                        <span className="input-group-text bg-transparent border-0">  <button
                                                            className="relative flex items-center gap-2 p-2 border rounded-lg bg-gray-800 text-white hover:bg-red-600 transition duration-300"
                                                            onMouseEnter={() => setHovered(true)}
                                                            onMouseLeave={() => setHovered(false)}
                                                        >
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                stroke="currentColor"
                                                                strokeWidth="2"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            >
                                                                <path d="M3 8V5a2 2 0 0 1 2-2h3" />
                                                                <path d="M21 16v3a2 2 0 0 1-2 2h-3" />
                                                                <path d="M3 3l18 18" />
                                                                <path d="M8 3h8a2 2 0 0 1 2 2v8m-4 4H8a2 2 0 0 1-2-2v-4" />
                                                            </svg>

                                                            {hovered && <span className="text-sm font-semibold">Disconnect Wallet</span>}
                                                        </button></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <button className="btn bg-theme-cyan border border-black shadow text-black w-100" id="proceed-to-pay-button"
                                                onClick={walletAddress ? (handleButtonClickMOdal) : () => setShowModal(true)}
                                                disabled={isLoading || isProceedButtonDisabled || amount < 10}><span className="px-3">
                                                    {walletAddress ? (isLoading ? "Processing..." : "Proceed to Pay") : "Connect Wallet"}
                                                </span></button>

                                            <div className="parentw">
                                                <div className="childw child-4w">
                                                    <a className="buttonw btn-4w" target='blank' href={`https://wa.me/?text=Join%20now%20using%20my%20referral%20ID%3A%20${referralUrl}`}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" height="1.1em" viewBox="0 0 448 512" fill="#25D366">
                                                            <path d="M380.9 97.1C339.4 55.6 283.8 32 224 32 100.3 32 0 132.3 0 256c0 45 11.9 89 34.5 127.4L3.4 480l100.9-30.7C142.6 471 182.5 480 224 480c123.7 0 224-100.3 224-224 0-59.8-23.6-115.4-67.1-157.9zM224 438c-37.1 0-73.3-9.8-104.7-28.3l-7.5-4.5-59.9 18.2 18.7-58.4-4.9-7.8C45 322 34 289.7 34 256 34 150.1 118.1 66 224 66c52.9 0 102.6 20.6 140 58 37.3 37.3 58 87 58 140 0 105.9-84.1 190-190 190zm101.5-137.7c-5.5-2.8-32.6-16.1-37.7-17.9-5.1-1.9-8.8-2.8-12.6 2.8-3.7 5.5-14.4 17.9-17.7 21.6-3.2 3.7-6.5 4.2-12 1.4-5.5-2.8-23.2-8.5-44.2-27-16.3-14.5-27.3-32.4-30.5-37.9-3.2-5.5-.3-8.4 2.4-11 2.5-2.5 5.5-6.5 8.3-9.7 2.8-3.2 3.7-5.5 5.5-9.2s0.9-7-0.5-9.7c-1.4-2.8-12.6-30.2-17.2-41.3-4.5-11-9-9.6-12.6-9.8-3.2-.2-6.9-.2-10.6-.2s-9.7 1.4-14.8 6.9c-5.1 5.5-19.4 19-19.4 46.4s19.9 53.9 22.7 57.6c2.8 3.7 39.1 59.6 94.7 83.5 13.2 5.7 23.5 9.2 31.6 11.7 13.3 4.2 25.4 3.6 35 2.2 10.7-1.6 32.6-13.3 37.2-26.2 4.6-13 4.6-24.1 3.2-26.2-1.4-2.2-5.1-3.6-10.6-6.4z" />
                                                        </svg>

                                                    </a>
                                                </div>
                                                <div className="childw child-1w">
                                                    <a className="buttonw btn-1w" >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="1em"
                                                            viewBox="0 0 512 512"
                                                            fill="#1e90ff"
                                                        >
                                                            <path d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z" />
                                                        </svg>
                                                    </a>
                                                </div>
                                                <div className="childw child-2w">
                                                    <a className="buttonw btn-2w">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="1em"
                                                            viewBox="0 0 448 512"
                                                            fill="#ff00ff"
                                                        >
                                                            <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                                                        </svg>
                                                    </a>
                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* countdown */}
            {/* about */}
            <div className="countdown-container py-5 bg-theme-cyan position-relative" id="About">
                <div className="element-2 rellax" data-rellax-speed={-2}><img src="assets/images/element-2.png" alt="element" /></div>
                <div className="container py-lg-5">
                    <div className="row justify-content-center">
                        <div className=" col-md-6 d-flex h-100 align-items-center mx-auto" style={{ marginTop: "-200px", marginLeft: "-20px" , marginBottom:"150px" }}>
                            <img src="assets/images/new3.png" alt="about" className="about-image rellax" data-rellax-speed={-1} />
                        </div>
                        <div className="col-lg-6 col-md-6 pe-lg-5 py-5">
                            <h2 className="display4-size ls-n5 theme-text-stork text-white mb-4 lh-5">About Snowball Coin</h2>
                            <p className="fs-18 lh-28 text-black mb-4">SnowballBoss is a next-generation memecoin built on the Binance Smart Chain (BSC), aiming to combine entertainment, finance, and community in an innovative and engaging way. Inspired by the mischievous Snowball from The <em> Secret Life of Pets </em>, SnowballBoss brings a playful spirit to the crypto space while offering unique features designed for both fun and functionality. With a focus on robust tokenomics, enhanced security measures, and a community-driven governance model, SnowballBoss is more than just a memecoin.</p>
                            <p className="fs-18 lh-28 text-black mb-4">—it’s a platform for innovation and connection. Whether you're a seasoned investor or new to crypto, SnowballBoss promises an exciting journey, blending the thrill of finance with the joy of community</p>
                            <a href="#Contact" className="btn bg-white border border-black shadow text-black px-4"><span className="px-3">Contact</span></a>
                        </div>
                    </div>
                    <div className="col-lg-12" id="HowToBuy">
                        <div className="d-flex justify-content-center pb-5">
                            <h2 className="display4-size ls-n5 theme-text-stork text-white py-lg-5 lh-5">How to Buy</h2>
                        </div>
                    </div>
                    <div className="row gx-4 gy-5">
                        <div className="col-lg-4">
                            <div className="howtobuy shadow p-4 border border-black pt-5 rounded-3 bg-theme-yellow text-black text-center position-relative">
                                <span className="rounded-pill w-6 h-6 position-absolute top-0 start-50 translate-middle display1-size bg-black text-white d-flex align-items-center text-center justify-content-center">1</span>
                                <h3 className="display1-size mb-3 mt-0">Connect Your Web3 Wallet</h3>
                                <p className="fs-18 lh-28 mb-2">Begin by connecting your Web3-compatible wallet, such as MetaMask or Trust Wallet, to the platform. Ensure that your wallet is set to the Binance Smart Chain (BSC) network for seamless transactions.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="howtobuy shadow p-4 border border-black pt-5 rounded-3 bg-theme-pink text-black text-center position-relative">
                                <span className="rounded-pill w-6 h-6 position-absolute top-0 start-50 translate-middle display1-size bg-black text-white d-flex align-items-center text-center justify-content-center">2</span>
                                <h3 className="display1-size mb-3 mt-0">Hold BNB for Transaction Fees</h3>
                                <p className="fs-18 lh-28 mb-2">To facilitate transactions on the Binance Smart Chain, ensure that your wallet contains a sufficient amount of BNB tokens to cover gas fees. This will enable smooth and uninterrupted transactions.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="howtobuy shadow p-4 border border-black pt-5 rounded-3 bg-theme-green text-black text-center position-relative">
                                <span className="rounded-pill w-6 h-6 position-absolute top-0 start-50 translate-middle display1-size bg-black text-white d-flex align-items-center text-center justify-content-center">3</span>
                                <h3 className="display1-size mb-3 mt-0">Fund Your Wallet with USDT (BEP-20)</h3>
                                <p className="fs-18 lh-28 mb-2">Ensure that you have USDT (BEP-20) in your wallet, as this will be used to swap for Snowball Memecoin. Once your wallet is funded, proceed to the swap interface to exchange USDT for Snowball tokens securely.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* countdown */}

            {/* tokenomics */}
            <div className="tokenomics-container" id="Tokenomics">
                <div className="element-3 rellax" data-rellax-speed={-2}><img src="assets/images/element-3.png" alt="element" /></div>
                <div className="element-4 rellax" data-rellax-speed={-1}><img src="assets/images/element-4.png" alt="element" /></div>
                <div className="tokenomics-wrap py-5 bg-theme-green">
                    <div className=" py-lg-4 container">
                        <div className="row align-items-center justify-content-center">
                            <div className="row justify-content-center col-md-8 col-12">
                                <div className="col-sm-12">
                                    <div className="d-flex flex-column justify-content-center text-center">
                                        <h2 className="display4-size ls-n5 theme-text-stork text-white lh-5">Tokenomics</h2>
                                        <h3 className="display1-size mb-3 mt-0 text-black lh-1">40% Liquidity Pool (1 billion tokens)</h3>
                                    </div>
                                </div>
                                <div className="col-sm-3 tokenomics-number d-none d-md-block d-lg-block d-xl-block d-xxl-block mb-5">
                                    <div className="d-flex flex-column align-items-end h-100">
                                        <div className="number-count d-flex flex-row gap-3 justify-content-end">
                                            <span className="display4-size text-cyan lh-3">15<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">Community Rewards <br /> & Airdrops</p>
                                        </div>
                                        <div className="number-count d-flex flex-row gap-3 justify-content-start my-auto mx-auto">
                                            <span className="display4-size text-orange lh-3">10<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">Team  <br /> Allocation</p>
                                        </div>
                                        <div className="number-count d-flex flex-row gap-3 justify-content-end mb-5">
                                            <span className="display4-size text-pink lh-3">15<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">Marketing &  <br /> Partnerships</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 px-0 mt-5">
                                    <canvas id="myPieChart" style={{ "height": "500px" }} />
                                </div>
                                <div className="col-sm-3 tokenomics-number d-none d-md-block d-lg-block d-xl-block d-xxl-block mb-5">
                                    <div className="d-flex flex-column align-items-end h-100">
                                        <div className="number-count d-flex flex-row gap-3 justify-content-start me-auto">
                                            <span className="display4-size text-info lh-3">10%<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">Presale <br /> Liquidity </p>
                                        </div>
                                        <div className="number-count d-flex flex-row gap-3 justify-content-start my-auto mx-auto">
                                            <span className="display4-size text-secondary lh-3">15<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">Development  <br />Reserve </p>
                                        </div>
                                        <div className="number-count d-flex flex-row gap-3 justify-content-end mb-5 me-auto">
                                            <span className="display4-size text-pink lh-3">35<b className="display1-size">%</b></span>
                                            <p className="text-black lh-6">DEX & CEX Listings</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 d-flex d-md-none d-lg-none d-xl-none d-xxl-none mt-3">
                                    <div className="row gy-4 ">
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-cyan lh-3">15<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">Community Rewards <br /> & Airdrops</p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-orange lh-3">10<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">Team  <br /> Allocation</p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-pink lh-3">15<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">Marketing &  <br /> Partnerships</p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-info lh-3">10<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">Presale <br /> Liquidity </p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-secondary lh-3">15<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">Development  <br />Reserve</p>
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="number-count d-flex flex-row gap-3 justify-content-center">
                                                <span className="display4-size text-pink lh-3">35<b className="display1-size">%</b></span>
                                                <p className="text-black lh-6">DEX & CEX Listings</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-12 snow-bunny-img">
                                <img
                                    ref={imageRef}
                                    src="assets/img/snowball1.png"
                                    className="image-animation img-fluid"
                                    alt="MemeCoin image"
                                />
                            </div>
                        </div>

                        <div className="row gy-4 gx-4" id="Roadmap">
                            <div className="col-sm-12 py-5">
                                <div className="d-flex flex-column justify-content-center text-center">
                                    <h2 className="display4-size ls-n5 theme-text-stork text-white lh-5">Roadmap</h2>
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="howtobuy shadow p-4 border border-black rounded-3 bg-theme-yellow text-black text-start position-relative">
                                    <h3 className="display1-size mb-2 mt-0">Q1 2025</h3>
                                    <p className="fs-18 lh-28 mb-1"> 🚀 Launch & Initial Growth</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="howtobuy shadow p-4 border border-black rounded-3 bg-theme-cyan text-black text-start position-relative">
                                    <h3 className="display1-size mb-2 mt-0">Q2 2025</h3>
                                    <p className="fs-18 lh-28 mb-1"> 🌍 Community Building</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="howtobuy shadow p-4 border border-black rounded-3 bg-theme-pink text-black text-start position-relative">
                                    <h3 className="display1-size mb-2 mt-0">Q3 2025</h3>
                                    <p className="fs-18 lh-28 mb-1">🎉 Growth & Expansion</p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="howtobuy shadow p-4 border border-black rounded-3 bg-light-secondary text-black text-start position-relative">
                                    <h3 className="display1-size mb-2 mt-0">Q4 2025</h3>
                                    <p className="fs-18 lh-28 mb-1">⚙️ Scaling</p>
                                </div>
                            </div> */}
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                <div className="timelineo">
                                    <div className="timeline-container">
                                        {timelineItems.map((item, index) => (
                                            <motion.div
                                                key={index}
                                                ref={(el) => (refs.current[index] = el)}
                                                initial={{ opacity: 0, scale: 0.5 }}
                                                animate={inViewStates[index] ? { opacity: 1, scale: 1 } : {}}
                                                transition={{ stiffness: 120, damping: 14, duration: 0.5 }}
                                                className={`timeline-block ${["left", "right", "left1", "right1"][index % 4] || ""
                                                    }`}
                                            >
                                                <div className="timeline-stepo">
                                                    <div className="timeline-contento">
                                                        <div>{item.date}</div>
                                                        <div className="timeline-descriptiono">
                                                            <h5 className="display1-size mb-2 mt-0">{item.title}</h5>
                                                            <p className="fs-18 lh-28 mb-1">{item.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </motion.div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
            {/* tokenomics */}
            {/* <Tokenomics /> */}

            {/* <div className="presale-container">
                
                <div className="presale-header" id="buysnowball">
                    <h1 className="weird-header">SNOWBALL PRESALE</h1>
                </div>
                <div className="coin-details">
                    <div className="coin-card">
                        <div className="reverse-clock time-item mb-3">{timeLeft}</div>
                        <p>introductory Price: $0.01</p>
                        <p>Total Supply: 1B</p>
                        <p>Presale Supply: 100M</p>
                    </div>
                </div>


                <div className="weird-inputs ">
                    <label><b>Your Referral Code</b></label>

                    <div className="referral-input-box">
                        <input
                            type="text"
                            value={userReferralId || ""}
                            readOnly // Read-only if there is a userReferralId
                            className="use-referral"
                            placeholder={
                                userReferralId?.length !== 6
                                    ? "Referral must be 6 characters"
                                    : "Enter Referral ID"
                            }
                            onChange={(e) => setUserReferralId(e.target.value)} // Assuming you want to update the referral ID
                        />
                    </div>

                </div>
                <div className="exchange-container1">
                    <div className="exchange-container weird-inputs">
                        <label><b>Pay with USDT (Bep20)</b></label>
                        <div className="exchange-section weird-input2">

                            <div className="currency-row">
                                <>
                                    
                                    <svg
                                        id="Layer_1"
                                        data-name="Layer 1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 409.24 409.24"
                                        width={40}
                                    >
                                        <defs>
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html:
                                                        "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #58af9a;\n      }\n    "
                                                }}
                                            />
                                        </defs>
                                        <path
                                            className="cls-2"
                                            d="M409.24,204.62c0,113.01-91.61,204.62-204.62,204.62S0,317.63,0,204.62,91.61,0,204.62,0s204.62,91.61,204.62,204.62h0ZM409.24,204.62"
                                        />
                                        <path
                                            className="cls-1"
                                            d="M225.86,179.43v-24.16h54.98v-38.12h-152.58v38.12h55.12v24.16c-46.18,2.24-80.85,11.51-80.85,22.51s34.62,20.32,80.85,22.51v79.8h42.48v-79.8c46.18-2.21,80.85-11.48,80.85-22.51s-34.56-20.27-80.85-22.51h0ZM204.62,217.41c-50,0-90.55-7.74-90.55-17.04,0-8,29.53-14.74,69.26-16.54v27.3c6.83.3,13.94.49,21.24.49s14.45-.19,21.24-.49v-27.3c39.74,1.8,69.26,8.54,69.26,16.54.09,9.41-40.46,17.04-90.46,17.04h0ZM204.62,217.41"
                                        />
                                    </svg>
                                </>

                                <div className="currency-details">
                                    <p>USDT</p>
                                    <span>Bep20</span>
                                </div>

                                <input className="amount-input" type="number" placeholder="Min 10" min="10" value={amount}
                                    onChange={handleAmountChange} />


                            </div>
                        </div>
                        <label><b>You will get</b></label>
                        <div className="exchange-section weird-input2">
                            <div className="currency-row">

                                <img src="assets/img/front.png" className="header-coin" alt="USDT logo" />

                                <div className="currency-details">
                                    <p>Snowball</p>
                                    <span>SNOWBALL</span>
                                </div>

                                <input className="amount-input" type="number" placeholder="Snowballs..." min="101" value={displayValue}
                                    readOnly
                                    onChange={handleAmountChange} />

                            </div>

                        </div>
                    </div>
                </div>

                <div className="d-flex justify-content-center flex-column">
                    <div className="weird-inputs ">
                        
                        <label>Wallet address</label>
                        <div className="w-100">
                            <input
                                type="text"
                                className="weird-input2 col-12"
                                placeholder="Wallet Address"
                                value={walletAddress}
                                disabled
                            />

                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <button
                        className="pay-button"
                        id="proceed-to-pay-button"
                        onClick={walletAddress ? (handleButtonClickMOdal) : () => setShowModal(true)}
                        disabled={isLoading || isProceedButtonDisabled || amount < 10}
                    >
                        {walletAddress ? (isLoading ? "Processing..." : "Proceed to Pay") : "Connect Wallet"}
                    </button>
                </div>

            </div> */}


            {/* faq and contact */}
            <div className="faq-container pt-5 pb-4 bg-theme-cyan" id="Faq">
                <div className="container py-lg-5">
                    <div className="row justify-content-center">
                        <div className="col-sm-12">
                            <div className="d-flex flex-column justify-content-center text-center">
                                <h2 className="display4-size ls-n5 theme-text-stork text-white lh-5">Got Questions?</h2>
                                <h3 className="display1-size mb-3 mt-0 text-black lh-1"> We've Got Answers!</h3>
                            </div>
                        </div>
                        <div className="col-lg-8 mt-5">
                            <div className="accordion accordion-flush" id="accordionFlushExample">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                            What is SnowballBoss?
                                        </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <p className="fs-17 lh-28 mb-2"> SnowballBoss is a fun and chaotic memecoin aimed at supporting
                                                charitable causes while bringing joy and entertainment to the crypto
                                                community.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                            How can I join the SnowballBoss
                                            community?
                                        </button>
                                    </h2>
                                    <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <p className="fs-17 lh-28 mb-2">You can join the community by following us on social media platforms
                                                like Twitter, Telegram, and Discord, or by buying SNOWBOSS tokens.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                            How can I buy SNOWBOSS tokens?
                                        </button>
                                    </h2>
                                    <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <p className="fs-17 lh-28 mb-2"> SNOWBOSS tokens can be purchased through various exchanges or
                                                directly from the project's website after launching.</p>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour">
                                            How Do I Buy Presale?
                                        </button>
                                    </h2>
                                    <div id="flush-collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <p className="fs-17 lh-28 mb-2">I ditched the bamboo forest for the concrete jungle of New York to become the first panda in the meme elite, alongside Dogecoin, Shiba, Pepe, and all those cats!</p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* faq and contact */}
            {/* footer */}
            <div className="footer" id="Contact">
                <div className="footer-wrap py-5 bg-black">
                    <div className="container pt-lg-5 pb-lg-4 my-3">
                        <div className="row gy-4 gx-4">
                            <div className="col-lg-6 text-white">
                                <span className="h1">Subscribe Our Channel</span>
                                <form className="p-2 bg-gray-800 rounded-3 mt-3 w-lg-75">
                                    <div className="row ">
                                        <div className="col-8">
                                            <input type="text" className="form-control bg-transparent text-white fs-16 border-0" placeholder="Enter Email Address." />
                                        </div>
                                        <div className="col-4">
                                            <button className="btn bg-theme-cyan border border-black text-black w-100">Submit</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="col-lg-3 text-white">
                                <span className="h1">Contact</span>
                                <p className="lh-24 fs-16 mb-0 mt-3">Sunrise Tower, 15 Oceanview Avenue, Blue Bay City, Coastal State, 45890</p>
                            </div>
                            <div className="col-lg-3 text-white">
                                <span className="h1">Follow</span>
                                <ul className="navbar-nav mt-4 d-flex flex-row gap-3">
                                    <li><a href="#" aria-label="mastodon"><i className="bi-mastodon text-white display1-size" /></a></li>
                                    <li><a href="#" aria-label="telegram"><i className="bi-telegram text-white display1-size" /></a></li>
                                    <li><a href="#" aria-label="twitter"><i className="bi-twitter-x text-white display1-size" /></a></li>
                                    <li><a href="#" aria-label="instagram"><i className="bi-instagram text-white display1-size" /></a></li>
                                    <li><a href="#" aria-label="twitch"><i className="bi-twitch text-white display1-size" /></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Modal
                isOpen={showModal}
                onRequestClose={() => setShowModal(false)} // Close modal when user clicks outside or close button
                contentLabel="Connect Wallet Modal"
                className="modal-content text-center"
                overlayClassName="modal-overlay"
            >
                <h2>Connect Wallet</h2>
                <button onClick={() => connectWallet("metamask")}>MetaMask</button>
                {/* <button onClick={() => connectWallet("trustwallet")}>Trust Wallet</button>
                <button onClick={() => connectWallet("phantom")}>Phantom Wallet</button> */}
                <button className="mx-auto w-50 bg-danger mt-3" onClick={() => setShowModal(false)}>Close</button>
            </Modal>
            <Modal
                isOpen={showModalRefer}
                onRequestClose={() => setShowModalRefer(false)}
                contentLabel="Warning..."
                className="modal-content text-center"
                overlayClassName="modal-overlay"
            >
                <p>Are you sure you want to continue without Using a Referral ID? </p>
                <button onClick={handleButtonClick}>Yes</button>
                <button onClick={() => handleModalClose(false)}>No</button>
            </Modal>
        </div>
    );
}

export default NewPage;